import React, { useEffect, useRef, useState } from "react";
import { Button } from "reactstrap";

const TotpCodeInput = ({ onSubmit, loading, submitLabel = "Verify" }) => {
  const [digits, setDigits] = useState(["", "", "", "", "", ""]);
  const inputRefs = useRef([]);

  const code = digits.join("");
  const isComplete = digits.every((digit) => digit.trim() !== "");

  useEffect(() => {
    if (inputRefs.current[0]) {
      inputRefs.current[0].focus();
    }
  }, []);

  const handleDigitChange = (index, event) => {
    const numericValue = event.target.value.replace(/[^0-9]/g, "");

    if (numericValue.length <= 1) {
      const updated = [...digits];
      updated[index] = numericValue;
      setDigits(updated);

      if (numericValue.length === 1 && index < inputRefs.current.length - 1) {
        inputRefs.current[index + 1].focus();
      }
    }
  };

  const handleKeyDown = (index, event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      if (isComplete && !loading) {
        onSubmit(digits.join(""));
      }
      return;
    }
    if (event.key === "Backspace" && !digits[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (isComplete && !loading) {
      onSubmit(code);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "8px",
          marginTop: "16px",
        }}
      >
        {digits.map((digit, index) => (
          <input
            key={index}
            type="text"
            inputMode="numeric"
            maxLength={1}
            value={digit}
            onChange={(event) => handleDigitChange(index, event)}
            onKeyDown={(event) => handleKeyDown(index, event)}
            onKeyPress={(e) => {
              // Allow Enter so form / keyDown submit can run; block other non-digits
              if (e.key === "Enter") {
                return;
              }
              if (!/[0-9]/.test(e.key)) {
                e.preventDefault();
              }
            }}
            ref={(ref) => (inputRefs.current[index] = ref)}
            style={{
              width: "40px",
              height: "48px",
              textAlign: "center",
              fontSize: "20px",
              border: "1px solid #ced4da",
              borderRadius: "4px",
              outline: "none",
            }}
            aria-label={`Digit ${index + 1}`}
          />
        ))}
      </div>

      <div className="mt-4 text-center">
        <Button
          color="primary"
          className="w-md waves-effect waves-light"
          type="submit"
          disabled={!isComplete || loading}
        >
          {submitLabel}
        </Button>
      </div>
    </form>
  );
};

export default TotpCodeInput;
